let data = [
  {
    id: 1,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 9000000,
    income_negative: 7000000,
    income_positive: 10000000,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2023 00:00:00',
    get_account_id: null,
    year: '2023',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2024 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 7,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 1,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 115515,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 2,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2024 00:00:00',
    get_account_id: null,
    year: '2024',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2025 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 2,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 3,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2025 00:00:00',
    get_account_id: null,
    year: '2025',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2026 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 3,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 4,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2026 00:00:00',
    get_account_id: null,
    year: '2026',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2027 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 4,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 5,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2027 00:00:00',
    get_account_id: null,
    year: '2027',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2028 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 5,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 6,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2028 00:00:00',
    get_account_id: null,
    year: '2028',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2029 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 6,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 7,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2029 00:00:00',
    get_account_id: null,
    year: '2029',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2030 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 7,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 8,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2030 00:00:00',
    get_account_id: null,
    year: '2030',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2031 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 8,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 9,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2031 00:00:00',
    get_account_id: null,
    year: '2031',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2032 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 9,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 10,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2032 00:00:00',
    get_account_id: null,
    year: '2032',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2033 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 10,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 11,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2033 00:00:00',
    get_account_id: null,
    year: '2033',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2034 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 11,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 12,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2034 00:00:00',
    get_account_id: null,
    year: '2034',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2035 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 12,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 13,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2035 00:00:00',
    get_account_id: null,
    year: '2035',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2036 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 13,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 14,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2036 00:00:00',
    get_account_id: null,
    year: '2036',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2037 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 14,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 15,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2037 00:00:00',
    get_account_id: null,
    year: '2037',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2038 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 15,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 16,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2038 00:00:00',
    get_account_id: null,
    year: '2038',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2039 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 16,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 17,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2039 00:00:00',
    get_account_id: null,
    year: '2039',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2040 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 17,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 18,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2040 00:00:00',
    get_account_id: null,
    year: '2040',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2041 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 18,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 19,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2041 00:00:00',
    get_account_id: null,
    year: '2041',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2042 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 19,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 20,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2042 00:00:00',
    get_account_id: null,
    year: '2042',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2043 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 20,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 21,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2043 00:00:00',
    get_account_id: null,
    year: '2043',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2044 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 21,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 22,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2044 00:00:00',
    get_account_id: null,
    year: '2044',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2045 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 22,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 23,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2045 00:00:00',
    get_account_id: null,
    year: '2045',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2046 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 23,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 24,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2046 00:00:00',
    get_account_id: null,
    year: '2046',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2047 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 24,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 25,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2047 00:00:00',
    get_account_id: null,
    year: '2047',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2048 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 25,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 26,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2048 00:00:00',
    get_account_id: null,
    year: '2048',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2049 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 26,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 27,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2049 00:00:00',
    get_account_id: null,
    year: '2049',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2050 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 27,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 28,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2050 00:00:00',
    get_account_id: null,
    year: '2050',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2051 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 28,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 29,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2051 00:00:00',
    get_account_id: null,
    year: '2051',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2052 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 29,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 30,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2052 00:00:00',
    get_account_id: null,
    year: '2052',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2053 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 30,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 31,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2053 00:00:00',
    get_account_id: null,
    year: '2053',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2054 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 31,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 32,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2054 00:00:00',
    get_account_id: null,
    year: '2054',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2055 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 32,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 33,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2055 00:00:00',
    get_account_id: null,
    year: '2055',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2056 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 33,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 34,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2056 00:00:00',
    get_account_id: null,
    year: '2056',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2057 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 34,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 35,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2057 00:00:00',
    get_account_id: null,
    year: '2057',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2058 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 35,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 36,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2058 00:00:00',
    get_account_id: null,
    year: '2058',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2059 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 36,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 37,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2059 00:00:00',
    get_account_id: null,
    year: '2059',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2060 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 37,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 38,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2060 00:00:00',
    get_account_id: null,
    year: '2060',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2061 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 38,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 39,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2061 00:00:00',
    get_account_id: null,
    year: '2061',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2062 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 39,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 40,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2062 00:00:00',
    get_account_id: null,
    year: '2062',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2063 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 40,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 41,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2063 00:00:00',
    get_account_id: null,
    year: '2063',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2064 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 41,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 42,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2064 00:00:00',
    get_account_id: null,
    year: '2064',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2065 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 42,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
    added: true,
  },
  {
    id: 43,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2065 00:00:00',
    get_account_id: null,
    year: '2065',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2066 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 43,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
    added: true,
  },
  {
    id: 44,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2066 00:00:00',
    get_account_id: null,
    year: '2066',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2067 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 44,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
    added: true,
  },
  {
    id: 45,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2067 00:00:00',
    get_account_id: null,
    year: '2067',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2068 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 45,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 46,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2068 00:00:00',
    get_account_id: null,
    year: '2068',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2069 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 46,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 47,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2069 00:00:00',
    get_account_id: null,
    year: '2069',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2070 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 47,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 48,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2070 00:00:00',
    get_account_id: null,
    year: '2070',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2071 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 48,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 49,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2071 00:00:00',
    get_account_id: null,
    year: '2071',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2072 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 49,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 50,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2072 00:00:00',
    get_account_id: null,
    year: '2072',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2073 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 50,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 51,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2073 00:00:00',
    get_account_id: null,
    year: '2073',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2074 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 51,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 52,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2074 00:00:00',
    get_account_id: null,
    year: '2074',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2075 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 52,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 53,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2075 00:00:00',
    get_account_id: null,
    year: '2075',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2076 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 53,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 54,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2076 00:00:00',
    get_account_id: null,
    year: '2076',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2077 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 54,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 55,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2077 00:00:00',
    get_account_id: null,
    year: '2077',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2078 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 55,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 56,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2078 00:00:00',
    get_account_id: null,
    year: '2078',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2079 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 56,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 57,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2079 00:00:00',
    get_account_id: null,
    year: '2079',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2080 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 57,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 58,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2080 00:00:00',
    get_account_id: null,
    year: '2080',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2081 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 58,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 59,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2081 00:00:00',
    get_account_id: null,
    year: '2081',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2082 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 59,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 60,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2082 00:00:00',
    get_account_id: null,
    year: '2082',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2083 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 60,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 61,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2083 00:00:00',
    get_account_id: null,
    year: '2083',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2084 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 61,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 62,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2084 00:00:00',
    get_account_id: null,
    year: '2084',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2085 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 62,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 63,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2085 00:00:00',
    get_account_id: null,
    year: '2085',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2086 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 63,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 64,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2086 00:00:00',
    get_account_id: null,
    year: '2086',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2087 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 64,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 65,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2087 00:00:00',
    get_account_id: null,
    year: '2087',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2088 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 65,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
  {
    id: 66,
    user_id: 3,
    type_id: 1001,
    type_text: 'Зарплата',
    subcategory_id: null,
    subcategory_text: null,
    custom_type_id: null,
    group_type_id: null,
    group_type_text: null,
    custom_group_type_id: null,
    class_type_id: null,
    class_type_text: null,
    custom_class_type_id: null,
    action_id: null,
    group_id: null,
    payment_type_id: 2,
    group_text: null,
    original_income: 0,
    income: 0,
    income_neutral: 0,
    income_negative: 0,
    income_positive: 0,
    income_neutral_changed: null,
    income_negative_changed: null,
    income_positive_changed: null,
    additional_income: 250000,
    outcome: 5000000,
    outcome_changed: null,
    additional_outcome: 1000000,
    income_currency_id: 1,
    income_account_id: 8,
    income_period_type_id: 3,
    income_period: null,
    income_period_data: [],
    original_buy_sum: null,
    buy_account_id: null,
    buy_sum: null,
    buy_currency_id: null,
    buy_at: '01.01.2088 00:00:00',
    get_account_id: null,
    year: '2088',
    original_sell_sum: null,
    sell_account_id: null,
    sell_sum: null,
    sell_currency_id: null,
    sell_at: '01.01.2089 00:00:00',
    count: null,
    rate: null,
    rate_action: null,
    rate_type_id: null,
    rate_period_type_id: null,
    rate_period: null,
    part: null,
    tax: 0,
    tax_changed: null,
    name: null,
    name_text: null,
    comment: null,
    item_type: null,
    item_id: null,
    chain_id: 66,
    is_plan: null,
    is_main_income: null,
    is_regular_outcome: null,
    is_own: null,
    ranges: [],
    months: [
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 28,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 30,
            sum: 0,
          },
        ],
      },
      {
        month: 1,
        sum: 0,
        rows: [
          {
            day: 31,
            sum: 0,
          },
        ],
      },
    ],
    deposit_account_id: null,
    lotsize: null,
    morph: 'active',
    avg_own_date: null,
    avg_own_date_by_value: '',
    relations: [],
    is_unique: null,
    relation_sum: null,
    zenmoney_id: null,
    isin: null,
    ticker: null,
    buy_trades: [],
    sell_trades: [],
    obligation: 0,
    plan_goals: 0,
    plan_income: 0,
    fact_obligation: 0,
    fact_goals: 0,
    fact_income: 0,
    fact_additional_income: 0,
    fact_main_income: 0,
    fact_base_outcome: 0,
    fact_additional_outcome: 0,
    with_plan_goals: 0,
    without_plan_goals: 0,
    retired_goals: 0,
    balance: 0,
  },
];

export default data;
